<template>
  <div class="order-detail-info__animation-wrapper">
    <div class="order-detail-info">
      <!-- Название -->
      <div class="string">
        <div class="fields custom mb-field">
          <div class="order-input details-item-name">
            <div class="label required item-icon">№ {{ this.$vnode.key + 1 }}</div>
            <input
              :placeholder="namePlaceholder"
              :class="getErrorClass('name')"
              @blur="touchField('name')"
              type="text"
              style="padding-right: 25px !important"
              ref="nameField"
              v-model="name"
            />
            <i
              class="icon-cross"
              v-if="name"
              @click="clearName"
              @keypress="clearName"
              v-tooltip.top-center="{
                content: 'Очистить поле',
                trigger: 'hover click',
              }"
            ></i>
          </div>
        </div>
        <button
          v-if="dot.items.length > 1"
          @click="deleteItemFromDot({ dot, item })"
          class="close"
          v-tooltip.top-center="{
            content: 'Удалить груз',
            trigger: 'hover click',
          }"
        ></button>
      </div>
      <!-- Подсказки для названия-->
      <div class="suggestion-buttons">
        <div
          class="suggestion-btn"
          v-for="suggestion of suggestionValues"
          :key="suggestion.name"
          @click="chooseSuggestion(suggestion)"
          @keypress="chooseSuggestion(suggestion)"
        >
          <span class="suggestion-item" v-html="getSuggestionName(suggestion)"></span>
          <i
            v-if="!isMobile && suggestion.description"
            @click.stop
            class="icon-tooltip"
            v-tooltip.right-start="{ content: suggestion.description, trigger: 'hover click' }"
          />
          <i
            v-else-if="suggestion.description"
            @click.stop
            class="icon-tooltip"
            v-tooltip.bottom="{ content: suggestion.description, trigger: 'hover click' }"
          />
        </div>
      </div>
      <ValidationView :error-messages="getErrorMessages('name')" :transition="false" />

      <div class="string">
        <div class="fields three">
          <!-- Цена -->
          <div class="cost order-input-wrapper">
            <div class="order-input">
              <div class="cost-input input-group input-group-right">
                <input
                  type="number"
                  :placeholder="itemPricePlaceholder"
                  v-model.number="price"
                  ref="priceField"
                  @input="inputPriceHandler"
                  @blur="touchField('price')"
                  :class="getErrorClass('price')"
                />
                <input type="text" value="₽" disabled />
              </div>
              <i
                class="icon-tooltip cost-tooltip"
                v-tooltip.right-start="{
                  content: costTooltipMessage,
                  trigger: 'click hover',
                }"
              ></i>
            </div>
            <ValidationView :transition="false" :error-messages="getErrorMessages('price')" />
          </div>
          <!-- Вес -->
          <div class="order-input-wrapper weight">
            <div class="order-input input-group input-group-right" ref="weightFieldContainer">
              <input
                type="number"
                @blur="onBlurWeight"
                placeholder="Масса (в гр.)"
                v-model="weight"
                ref="weightField"
                v-if="showWeightInput"
                :class="getErrorClass('weight')"
              />
              <select
                name="weight"
                @blur="onBlurWeight"
                :class="getErrorClass('weight')"
                v-model="weight"
                v-else
              >
                <option
                  v-for="(value, index) in customAvailableWeighValues"
                  :key="value"
                  :value="value"
                >
                  <span>До {{ value / 1000 }} кг</span>
                  <span v-if="!index">(вес за 1 шт.)</span>
                </option>
                <option value="x">Указать точный вес</option>
              </select>
              <input type="text" :value="showWeightInput ? 'гр' : 'кг'" disabled />
            </div>
            <ValidationView :error-messages="getErrorMessages('weight')" :transition="false" />
          </div>
          <!-- Кол-во -->
          <div class="order-input-wrapper count">
            <div class="order-input">
              <div class="input-group input-group-right">
                <input
                  type="number"
                  @input="changeCountHandler"
                  v-model.number="count"
                  ref="countField"
                  :class="getErrorClass('count')"
                />
                <input type="text" value="шт" disabled />
              </div>
            </div>
            <ValidationView :error-messages="getErrorMessages('count')" :transition="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemMixin from '@apps/order-form/src/mixins/item'

export default {
  name: 'ItemComponent',
  mixins: [itemMixin],
}
</script>

<style lang="scss" scoped>
.order-detail-info__animation-wrapper {
  overflow-y: hidden;

  // чтобы тень при фокусе на полях ввода не пропадала из-за overflow
  margin: 0 -5px;
  padding: 0 5px;

  transition: all 0.6s;
}

.order-detail-info {
  padding: 5px 0;

  .details-item-name {
    position: relative;

    display: flex;
    grid-column: -1 / 1;

    .item-icon {
      margin-bottom: 0 !important;

      font-weight: normal;

      background-color: #fafafa;
    }
  }
}

.close {
  position: relative;

  width: 18px;
  height: 18px;
  margin-top: 8px;
  margin-left: 5px;

  font-size: 20px;
  color: #fff;

  background-color: #c9ced2;
  border: none;
  border-radius: 50%;

  transition: background-color 0.4s ease-out;

  &::before {
    content: '\ea0f';

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-52%, -45%);

    font-family: PeshkarikiFont !important;
    font-size: 11px;
  }

  &:hover {
    background-color: #787a7c;
  }

  // @media (max-width: 768px) {
  //   right: 0;
  // }
}

.label {
  display: flex !important;
  align-items: center;
  justify-content: center;

  font-size: 13px;
  font-weight: 700;

  &.required::after {
    top: 0 !important;
    right: 1px !important;
  }
}

option {
  z-index: 10;
}

.three {
  .order-input,
  .order-input-wrapper {
    @media (max-width: 768px) {
      grid-column: 1 / -1;

      max-width: 100% !important;
    }
  }
  @media (max-width: 768px) {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
  }
}

.suggestion-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 20px;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
  padding-left: 40px;

  // @media (max-width: 475px) {
  //   width: 100%;
  // }
  // @media (min-width: 992px) and (max-width: 1200px) {
  //   width: 100%;
  // }
  // @media (min-width: 575px) and (max-width: 768px) {
  //   width: 100%;
  // }

  .suggestion-btn {
    cursor: pointer;

    display: flex;
    align-items: center;

    font-size: 13px;
    font-weight: 500;
    color: #2f3e5c;

    .icon-tooltip {
      position: relative;

      margin: 0 5px;
    }

    .suggestion-item {
      display: inline-block;

      &::first-letter {
        text-transform: uppercase;
      }
    }

    span::deep .extra-price {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
  @media (max-width: 768px) {
    padding-left: 2px;
  }
}

.cost-tooltip {
  width: 14px;
  height: 14px;
  margin: 0 10px;
}
</style>
